<template>
  <div class="modal-drag-custom-drag" :class="$vuetify.breakpoint.mobile && 'mobile-popup'" :style="{ zIndex: indexModalIndex }">
		<modal
			name="custom_drag_modal"
			:style="{ zIndex: indexModalIndex }"
			hide-overlay
			draggable=".drag-header"
			:clickToClose="true"
			@before-close="closeModal"
			:focusTrap="true"
			:adaptive="true"
			height="auto"
		>
      <v-card>
        <v-card-title class="pa-0 drag-header">
					<div class="d-flex flex-row align-center justify-space-between py-2 px-8 w-100">
						<div class="d-flex flex-row align-center">
							<v-icon color="white" class="info-icon mr-2">mdi-information-symbol</v-icon>
							<p class="mb-0 font-weight-bold text-primary title">Datos Empresa</p>
						</div>
						<v-btn class="mx-2" fab dark small color="#FF1209" @click="closeModal">
							<v-icon dark>mdi-close</v-icon>
						</v-btn>
					</div>
				</v-card-title>
        <v-card-text class="pa-0">
          <div class="py-4 px-8">
            <v-form ref="form" v-model="validform" class="mt-6">
              <v-row class="mb-1">
                <v-col cols="12">
									<v-btn-toggle
										v-model="selectedTab"
										dense
										class="d-flex flex-row custom-toggle-btns"
									>
										<v-btn :value="1" class="flex-grow-1"
											:color="selectedTab == 1 ? '#FF1209':''">
											<p class="mb-0 caption font-weight-bold" :class="selectedTab == 1 ? 'white--text':''">Datos de Empresa</p>
										</v-btn>
										<v-btn :value="2" class="flex-grow-1"
											:color="selectedTab == 2 ? '#FF1209':''">
											<p class="mb-0 caption font-weight-bold" :class="selectedTab == 2 ? 'white--text':''">Datos de Transferencia</p>
										</v-btn>
									</v-btn-toggle>
								</v-col>
							</v-row>
							<div class="pa-4" v-if="selectedTab == 1">
								<v-row class="mb-4 mt-2">
									<v-col cols="12" md="2" class="py-0">
										<v-avatar
											size="80"
											class="profile-avatar"
											@click="triggerFileInput"
										>
											<img :src="logoUrl" class="user-avatar" v-if="logoUrl && logoUrl"/>
											<v-icon v-else class="user-avatar" color="#524D4D" x-large>mdi-image</v-icon>
											<div class="logo-text">Modificar Logo</div>
										</v-avatar>
										<v-file-input
											ref="fileInputLogo"
											v-model="newCompany.logo"
											show-size
											outlined
											dense
											accept=".png,.jpg,.jpeg"
											placeholder="Seleccione imagen de perfil"
											prepend-inner-icon="mdi-image"
											prepend-icon=""
											style="display: none;"
											@change="onFileSelected"
										></v-file-input>
									</v-col>
									<v-col cols="12" md="10" class="py-0">
										<v-row>
											<v-col cols="12" class="py-0">
												<v-text-field
													v-model="newCompany.legal_name"
													label="Nombre Legal (SII)"
													placeholder="Ingrese el nombre legal de la empresa"
													outlined
													required
													dense
													:rules="requiredRule"
												></v-text-field>
											</v-col>
											<v-col cols="12" class="py-0">
												<v-text-field
													v-model="newCompany.name"
													label="Nombre de Fantasía"
													placeholder="Ingrese nombre de fantasía de la empresa"
													outlined
													required
													dense
													:rules="requiredRule"
												></v-text-field>
											</v-col>
										</v-row>
									</v-col>
								</v-row>
								<v-row>
									<v-col cols="12" class="py-0">
										<v-text-field
											v-model="newCompany.rut"
											label="Rut"
											placeholder="Ingrese el rut de la empresa"
											outlined
											required
											dense
											hint="Ingresa rut sin puntos ni guión"
											:rules="rutRule"
											@blur="onBlurRut"
											@focus="onFocusRut"
											maxlength="9"
										></v-text-field>
									</v-col>
									<v-col cols="12" class="py-0">
										<v-text-field
											v-model="newCompany.description"
											label="Descripción"
											placeholder="Ingrese una descripción para la empresa"
											outlined
											required
											dense
											:rules="requiredRule"
										></v-text-field>
									</v-col>
									<v-col cols="12" class="py-0">
										<v-text-field
											v-model="newCompany.email"
											label="Email"
											placeholder="Ingrese email de contacto"
											outlined
											required
											dense
											:rules="emailRules"
										></v-text-field>
									</v-col>
									<v-col cols="12" class="py-0">
										<v-text-field
											v-model="newCompany.phone"
											label="Teléfono"
											placeholder="Ingrese teléfono de contacto (Ej: 56912345678)"
											outlined
											required
											dense
											:rules="phoneRule"
											maxlength="11"
											@keypress="isNumberKey"
										></v-text-field>
									</v-col>
									<v-col cols="12" class="py-0">
										<v-text-field
											v-model="newCompany.address"
											label="Dirección"
											placeholder="Ingrese direccción completa de la empresa"
											outlined
											required
											dense
											:rules="requiredRule"
										></v-text-field>
									</v-col>
									<v-col cols="12" class="py-0">
										<v-select
											v-model="newCompany.state_id"
											:items="$store.state.general.states"
											:loading="$store.state.general.loadingStates"
											:menu-props="{ top: true, offsetY: true }"
											item-text="name"
											item-value="id"
											label="Seleccione Región"
											outlined
											dense
											required
											:rules="requiredRule"
											@change="onChangeState"
										></v-select>
									</v-col>
									<v-col cols="12" class="py-0">
										<v-select
											v-model="newCompany.city_id"
											:items="$store.state.general.cities"
											:loading="$store.state.general.loadingCities"
											item-text="name"
											item-value="id"
											label="Seleccione Comuna"
											outlined
											dense
											required
											:disabled="!newCompany.state_id"
											:rules="requiredRule"
										></v-select>
									</v-col>
									<v-col cols="12" class="py-0">
										<v-text-field
											v-model="newCompany.url"
											label="Url sitio web"
											placeholder="Ingrese url del sitio web"
											outlined
											required
											dense
											:rules="requiredRule"
										></v-text-field>
									</v-col>
									<v-col cols="12" class="py-0">
										<v-select
											v-model="newCompany.responsible"
											:items="$store.state.users.usersList"
											:loading="$store.state.users.loadingUserList"
											item-text="profile.name"
											item-value="id"
											label="Usuario responsable"
											outlined
											dense
											required
											hide-details
											:rules="requiredRule"
										>
											<template v-slot:item="data">
												<v-list-item-content>
													<div class="d-flex align-center">
														<img :src="data?.item?.profile?.avatar" class="user-avatar mr-2" v-if="data?.item?.profile?.avatar"/>
														<v-icon v-else class="user-avatar icon mr-2" color="#524D4D">mdi-account</v-icon>
														<div>
															<p class="mb-0 caption">{{ data?.item?.profile?.name }} {{ data?.item?.profile?.lastname }} {{ data?.item?.profile?.second_lastname }}</p>
															<p class="mb-0 caption">{{ data?.item?.email }}</p>
														</div>
													</div>
												</v-list-item-content>
											</template>
											<template #append-outer>
												<v-btn
													class="my-0"
													icon
													@click="addUser"
												>
													<v-icon>mdi-account-plus</v-icon>
												</v-btn>
											</template>
										</v-select>
									</v-col>
									<v-col cols="12" class="py-0" v-if="userInfo?.super_admin_user">
										<v-checkbox 
											v-model="newCompany.supervision_allowed" 
											color="black" 
											label="Puede utilizar sección de Patrocinio" 
											hide-details 
											dense
										></v-checkbox>
									</v-col>
								</v-row>
							</div>
							<div class="px-4 py-1" v-if="selectedTab == 2">
								<p class="mb-0 font-weight-bold">Datos de Cuenta Bancaria para Transferencias</p>
								<v-row class="mt-1">
									<v-col cols="12" md="6" class="py-0">
										<v-select
											v-model="bankAccount.bank_name"
											:items="banksList"
											label="Banco"
											placeholder="Seleccione el banco"
											outlined
											dense
											:rules="requiredRule"
										></v-select>
									</v-col>
									<v-col cols="12" md="6" class="py-0">
										<v-select
											v-model="bankAccount.account_type"
											:items="accountTypes"
											label="Tipo de Cuenta"
											placeholder="Seleccione tipo de cuenta"
											outlined
											dense
											:rules="requiredRule"
										></v-select>
									</v-col>
									<v-col cols="12" md="6" class="py-0">
										<v-text-field
											v-model="bankAccount.account_number"
											label="Número de Cuenta"
											placeholder="Ingrese número de cuenta"
											outlined
											dense
											:rules="requiredRule"
										></v-text-field>
									</v-col>
									<v-col cols="12" md="6" class="py-0">
										<v-text-field
											v-model="bankAccount.account_holder_name"
											label="Nombre del Titular"
											placeholder="Ingrese nombre del titular"
											outlined
											dense
											:rules="requiredRule"
										></v-text-field>
									</v-col>
									<v-col cols="12" md="6" class="py-0">
										<v-text-field
											v-model="bankAccount.account_holder_rut"
											label="RUT del Titular"
											placeholder="Ingrese RUT del titular"
											outlined
											dense
											hint="Ingresa rut sin puntos ni guión"
											:rules="rutRule"
											@blur="onBlurRutBank"
											@focus="onFocusRutBank"
											maxlength="9"
										></v-text-field>
									</v-col>
									<v-col cols="12" md="6" class="py-0">
										<v-text-field
											v-model="bankAccount.email"
											label="Email de Contacto"
											placeholder="Ingrese email de contacto"
											outlined
											dense
											:rules="emailRules"
										></v-text-field>
									</v-col>
									<!-- <v-col cols="12" class="py-0">
										<v-checkbox 
											v-model="bankAccount.is_default" 
											color="black" 
											label="Establecer como cuenta por defecto" 
											hide-details 
											dense
										></v-checkbox>
									</v-col> -->
								</v-row>
							</div>

              <v-row align="center">
                <v-col cols="12">
                  <div class="d-flex flex-row justify-end">
                    <v-btn
                      class="mx-2 my-1"
                      color="white"
                      raised
                      @click="closeModal"
                    >
                      <p class="mb-0 text-primary">Cancelar</p>
                    </v-btn>
                    <v-btn
                      class="mx-2 my-1"
                      color="#524D4D"
                      raised
                      dark
                      :loading="loadingData"
                      @click="sendForm"
                    >
                      <p class="mb-0">Confirmar</p>
                    </v-btn>
                  </div>
                </v-col>
              </v-row>
            </v-form>
          </div>
        </v-card-text>
      </v-card>
    </modal>
  </div>
</template>

<script>
import { eventBus } from '@/components/Helpers/Events/NotificationsEventBus'
import {createCompany, updateCompany, updateOrCreateBankAccount} from '@/helpers/api/company'
import {validate, format, clean} from '@/helpers/rut.js'

export default {
  name: 'CompanyModal',
  components: { },
  computed: {
		indexModalIndex(){
			const ordered = [...this.$store.state.general.openModalOrders].sort((a, b) => a - b)
			return ordered.indexOf(this.indexModal) + 10
		},
		userInfo(){
			return this.$store.state.user.userInfo
		},
		selectedCompany(){
			return this.$store.state.companies.selectedCompany
		}
  },
	watch: {
		selectedTab(newVal) {
			if (newVal === 2) {
				if (!this.bankAccount.account_holder_rut && this.newCompany.rut) {
					this.bankAccount.account_holder_rut = this.newCompany.rut
				}
				if (!this.bankAccount.account_holder_name && this.newCompany.legal_name) {
					this.bankAccount.account_holder_name = this.newCompany.legal_name
				}
				if (!this.bankAccount.email && this.newCompany.email) {
					this.bankAccount.email = this.newCompany.email
				}
			}
		}
	},
  data: () => ({
		indexModal: + new Date(),
    validform: true,
		loadingData: false,
		selectedTab: 1,
    newCompany: {
			company_id: null,
			name: null,
			description: null,
			logo: null,
			url: null,
			rut: null,
			address: null,
			legal_name: null,
			responsible: null,
			state_id: null,
			phone: null,
			email: null,
			city_id: null,
			supervision_allowed: false
    },
		bankAccount: {
			bank_name: null,
			account_type: null,
			account_number: null,
			account_holder_name: null,
			account_holder_rut: null,
			email: null,
			is_default: false
		},
		accountTypes: [
			'Cuenta Corriente',
			'Cuenta Vista',
			'Cuenta de Ahorro'
		],
		banksList: [
			'BANCO DE CHILE',
			'BANCO INTERNACIONAL',
			'SCOTIABANK CHILE',
			'BANCO DE CREDITO E INVERSIONES',
			'BANCO BICE',
			'HSBC BANK (CHILE)',
			'BANCO SANTANDER-CHILE',
			'BANCO ITAÚ CHILE',
			'BANCO SECURITY',
			'BANCO FALABELLA',
			'BANCO RIPLEY',
			'BANCO CONSORCIO',
			'BANCO BTG PACTUAL CHILE',
			'TANNER BANCO DIGITAL',
			'JP MORGAN CHASE BANK, N. A.',
			'CHINA CONSTRUCTION BANK, AGENCIA EN CHILE',
			'BANK OF CHINA, AGENCIA EN CHILE',
			'BANCO DEL ESTADO DE CHILE'
		],
		logoUrl: null,
		rutRule: [
			v => validate(v) || 'Rut no válido'
		],
    requiredRule: [
      v => !!v || 'Campo requerido'
    ],
    phoneRule: [
			v => !!v || 'Campo requerido',
			v => /^569\d{8}$/.test(v) || 'Debe tener 11 dígitos y empezar con 569',
    ],
    emailRules: [
      v => !!v || 'Email es obligatorio',
      v => /.+@.+\..+/.test(v) || 'Email debe ser válido',
    ],
  }),
  mounted(){
		if(this.$store.state.companies.newCompanyModalEditing){
			this.newCompany = this.$store.state.companies.newCompanyModalEditing
			this.logoUrl = this.$store.state.companies.newCompanyModalEditing.logo
			// this.newCompany.responsible = this.$store.state.user.userInfo.id
			this.newCompany.logo = null
			this.newCompany.supervision_allowed = this.$store.state.companies.newCompanyModalEditing.supervision_allowed || false
			if(this.newCompany.state_id){
				this.onChangeState(this.newCompany.state_id)
			}
			if(this.$store.state.companies.newCompanyModalEditing.bank_account){
				const bankData = this.$store.state.companies.newCompanyModalEditing.bank_account
				this.bankAccount = {
					update_company_id: this.newCompany.company_id,
					bank_name: bankData.bank_name,
					account_type: bankData.account_type,
					account_number: bankData.account_number,
					account_holder_name: bankData.account_holder_name,
					account_holder_rut: bankData.account_holder_rut,
					email: bankData.email,
					is_default: bankData.is_default
				}
			}
		}
		this.$store.dispatch('users/getUserFromCompany')
		this.$modal.show('custom_drag_modal')
		this.$store.commit('general/addOpenModalOrders', this.indexModal)
  },
  methods: {
		isNumberKey(event) {
			const charCode = event.which ? event.which : event.keyCode;
			if (charCode < 48 || charCode > 57) {
				event.preventDefault();
			}
		},
		onBlurRut(){
			if(validate(this.newCompany.rut)){
				this.newCompany.rut = format(this.newCompany.rut)
			}
		},
		onFocusRut(){
			if(validate(this.newCompany.rut)){
				this.newCompany.rut = clean(this.newCompany.rut)
			}
		},
		onBlurRutBank(){
			if(validate(this.bankAccount.account_holder_rut)){
				this.bankAccount.account_holder_rut = format(this.bankAccount.account_holder_rut)
			}
		},
		onFocusRutBank(){
			if(validate(this.bankAccount.account_holder_rut)){
				this.bankAccount.account_holder_rut = clean(this.bankAccount.account_holder_rut)
			}
		},
		onChangeState(state){
			this.$store.dispatch('general/getCities', state)
		},
    addUser() {
			this.$store.commit('users/setNewUserModalEditing', null)
			this.$store.commit('users/setNewUserModal', true)
    },
    triggerFileInput() {
      this.$refs.fileInputLogo.$el.querySelector('input[type="file"]').click();
    },
    onFileSelected(file) {
      if (file) {
        const reader = new FileReader()
        reader.onload = (e) => {
          this.logoUrl = e.target.result
        };
        reader.readAsDataURL(file)
      }
    },
    closeModal(){
      this.$store.commit('companies/setNewCompanyModal', false)
			this.$store.commit('companies/setNewCompanyModalEditing', null)
      this.newCompany = {
				company_id: null,
				name: null,
				description: null,
				logo: null,
				url: null,
				rut: null,
				address: null,
				legal_name: null,
				responsible: null,
				phone: null,
				email: null,
				state_id: null,
				city_id: null,
				supervision_allowed: false
			}
			this.bankAccount = {
				bank_name: null,
				account_type: null,
				account_number: null,
				account_holder_name: null,
				account_holder_rut: null,
				email: null,
				is_default: false
			}
			this.selectedTab = 1
      this.validform = true
      this.loadingData = false
    },
    async sendForm(){
      if(this.$refs.form.validate()){
				this.loadingData = true
    
				await Promise.all([
					this.saveCompanyData(),
					this.saveBankAccountData()
				]);
				
				eventBus.$emit('reloadInformation')
				this.loadingData = false
				this.closeModal()
      }
    },
		
		async saveCompanyData(){
			const formData = new FormData()
			let newCompany = {...this.newCompany}
			newCompany.rut = clean(newCompany.rut)
			newCompany.update_company_id = newCompany.company_id
			Object.keys(newCompany).forEach((key) => {
				if(newCompany[key]) {
					formData.append(key, newCompany[key])
				}
			})
			const company = this.newCompany.company_id ? await updateCompany(formData) : await createCompany(formData)
			if(company.code === 200){
				const messageData = {
					message: 'Se ha guardado correctamente la empresa',
					title: 'Empresa guardada',
					type: 'success',
					icon: 'mdi-check-circle',
					color: '#3EBFA3',
				}
				this.$store.dispatch('companies/getCompaniesList', {})
				this.setMessage(messageData)
				const company_id = newCompany.company_id
				this.checkSelectedCompany(company_id)
			}
			else{
				const messageData = {
					message: 'Hubo un error en la operación, por favor intenta nuevamente',
					title: 'Ha ocurrido un error',
					type: 'danger',
					icon: 'mdi-close-octagon',
					color: '#FF1209',
				}
				this.setMessage(messageData)
			}
		},
		checkSelectedCompany(company_id){
			if(this.selectedCompany && company_id == this.selectedCompany.company_id){
				this.$store.dispatch('user/getUserInfo')
			}
		},
		async saveBankAccountData(){
			if(!this.newCompany.company_id) {
				const messageData = {
					message: 'Debe guardar primero los datos de la empresa',
					title: 'Empresa no guardada',
					type: 'warning',
					icon: 'mdi-alert',
					color: '#FF9800',
				}
				this.setMessage(messageData)
				this.selectedTab = 1
				return
			}
			
			const formData = new FormData()
			let bankAccount = {
				...this.bankAccount,
				company_editting_id: this.newCompany.company_id,
				update_company_id: this.newCompany.company_id,
			}
			
			if(bankAccount.account_holder_rut) {
				bankAccount.account_holder_rut = clean(bankAccount.account_holder_rut)
			}
			
			Object.keys(bankAccount).forEach((key) => {
				if(typeof bankAccount[key] === 'boolean') {
					formData.append(key, bankAccount[key] ? '1' : '0')
				}
				else if(bankAccount[key] !== null && bankAccount[key] !== undefined && bankAccount[key] !== '') {
					formData.append(key, bankAccount[key])
				}
			})
			
			const result = await updateOrCreateBankAccount(formData)
			if(result.code === 200){
				const messageData = {
					message: 'Se ha guardado correctamente la cuenta bancaria',
					title: 'Cuenta bancaria guardada',
					type: 'success',
					icon: 'mdi-check-circle',
					color: '#3EBFA3',
				}
				this.setMessage(messageData)
			}
			else{
				const messageData = {
					message: 'Hubo un error al guardar la cuenta bancaria, por favor intenta nuevamente',
					title: 'Ha ocurrido un error',
					type: 'danger',
					icon: 'mdi-close-octagon',
					color: '#FF1209',
				}
				this.setMessage(messageData)
			}
		},
		
    setMessage(messageData){
      const data = {
        message: messageData.message,
        title: messageData.title,
        created: new Date(),
        type: messageData.type,
        icon: messageData.icon,
        color: messageData.color,
      }
      this.$store.dispatch('general/addMessage', data)
    },
  }
};
</script>

<style scoped>
	.profile-avatar{
		cursor: pointer;
		position: relative;
	}
	.logo-text{
		position: absolute;
		bottom: 0;
		background-color: rgba(0, 0, 0, 0.7);
		width: 100%;
		color: white;
		font-size: 12px;
		padding-bottom: 10px;
		padding-top: 3px;
	}
  .info-container{
    color: #606060;
  }
  .text-primary{
    color: #524D4D;
  }
  .info-icon{
    background-color: #524D4D;
    border-radius: 25px;
    padding: 3px;
    width: 35px;
    height: 35px;
  }
  .info-icon.small-icon{
    width: 25px;
    height: 25px;
  }
  .info-img{
    width: 100%;
    max-height: 50px;
    object-fit: contain;
  }
  .adjuntos-container{
    background-color: #EFEFEF;
    max-height: 95px;
    overflow-y: scroll;
  }
  .interaction-container{
    width: 100%;
    background-color: #E5E9F2;
    border-radius: 5px;
    position: relative;
    padding: 12px;
  }
  .user-avatar.small{
    width: 25px;
    height: 25px;
  }
  .light-blue-text{color: #959595;}
  .interaction-container .icon-arrow{
    font-size: 80px;
    position: absolute;
    top: 20px;
    line-height: inherit;
  }
  .interaction-container.right .icon-arrow{
    left: -46px;
  }
  .interaction-container.left .icon-arrow{
    right: -46px;
  }
	.custom-toggle-btns .v-btn--active:before{
		opacity: 0;
	}
  /deep/ .custom-input-numbers .v-input__slot{padding:0!important;}
  /deep/ .custom-input-numbers .v-input__prepend-inner,
  /deep/ .custom-input-numbers .v-input__append-inner,
  /deep/ .custom-text-input .v-input__append-inner{margin-top:0!important;}
  /deep/ .custom-input-numbers input {text-align: center }
</style>